module.exports = __webpack_public_path__ + "components/thanks/static/thanks-9e2ed956e587fc86b2d88fa8c2fd34a4.svg";